import { AlertCircle } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";

/**
 * Mai-2026 — Popup für fehlende Pflichtfelder.
 *
 * Erscheint, wenn der User beim Klick auf „Speichern" Pflichtfelder leer
 * gelassen hat. Jede Pille führt direkt zum jeweiligen Feld.
 */
export default function MissingFieldsDialog({ open, onClose, missing = [], jumpTo }) {
    const count = missing.length;
    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
            <DialogContent className="max-w-md" data-testid="missing-fields-dialog">
                <DialogHeader>
                    <div className="flex items-center gap-2">
                        <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-red-100 text-red-700">
                            <AlertCircle className="w-5 h-5" />
                        </span>
                        <DialogTitle className="font-display font-black text-lg" data-testid="missing-fields-dialog-title">
                            {count === 1 ? "1 Pflichtfeld fehlt noch" : `${count} Pflichtfelder fehlen noch`}
                        </DialogTitle>
                    </div>
                    <DialogDescription className="text-sm text-gray-700 mt-2">
                        Bitte fülle die markierten Felder aus, bevor du das Inserat veröffentlichst. Ein Klick auf eine Pille springt direkt zum Feld.
                    </DialogDescription>
                </DialogHeader>

                <div className="flex flex-wrap gap-1.5 max-h-64 overflow-y-auto" data-testid="missing-fields-dialog-list">
                    {missing.map((m) => (
                        <button
                            key={m.key}
                            type="button"
                            onClick={() => jumpTo(m.selector)}
                            className="inline-flex items-center gap-1 text-[11px] font-bold text-red-800 bg-red-50 border border-red-300 rounded-sm px-2 py-1 hover:bg-red-100"
                            data-testid={`missing-fields-dialog-jump-${m.key}`}
                        >
                            <span className="text-red-600">●</span> {m.label}
                        </button>
                    ))}
                </div>

                <DialogFooter className="flex sm:justify-between gap-2 pt-2">
                    <Button type="button" variant="outline" onClick={onClose} data-testid="missing-fields-dialog-close">
                        Weiter bearbeiten
                    </Button>
                    {missing[0]?.selector && (
                        <Button
                            type="button"
                            onClick={() => jumpTo(missing[0].selector)}
                            className="bg-[#111827] hover:bg-black text-[#FFCC00] font-bold rounded-sm uppercase tracking-wider"
                            data-testid="missing-fields-dialog-jump-first"
                        >
                            Zum ersten Feld
                        </Button>
                    )}
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
